import { CustomerTenant } from "./customer-tenant";

export class Customer {
  id?: string;
  code?: string;
  displayName?: string;
  active?: boolean;
  maxConcurrentUsers?: number;
  createTime?: number;
  updateTime?: number;
  tenants?: CustomerTenant[];
  emailDomains?: string[];
}
